module.exports = __webpack_public_path__ + "5a6e2e1234d3a96ce3487a160d11f79a.png";